module.exports = __webpack_public_path__ + "media/lobby_normal2.5b141a76.mp3";